import { ReactNode } from 'react';

import './SectionCard.scss';

interface ISectionCardProps {
  title: string | ReactNode;
  trailingComponent?: ReactNode;
  children: ReactNode;
  className?: string;
}

const SectionCard = ({ title, trailingComponent, children, className = '' }: ISectionCardProps) => {
  return (
    <section className={`section-card ${className}`.trim()}>
      <header className="section-card__header">
        <span className="section-card__title">{title}</span>
        {trailingComponent && <div className="section-card__trailing">{trailingComponent}</div>}
      </header>

      <div className="section-card__separator" />
      {children}
    </section>
  );
};

export default SectionCard;
